module.exports = __webpack_public_path__ + "assets/img/00145.770cf710.png";